import { render } from "./AgentAgencyDetails.vue?vue&type=template&id=528f9e24&scoped=true&lang=pug"
import script from "./AgentAgencyDetails.vue?vue&type=script&lang=js"
export * from "./AgentAgencyDetails.vue?vue&type=script&lang=js"

import "./AgentAgencyDetails.vue?vue&type=style&index=0&id=528f9e24&lang=scss&scoped=true"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-528f9e24"]])

export default __exports__